export const weeklySubscriptions = `
  query WeeklySubscriptions {
    weeklySubscriptions {
      id
      email
      queryString
      jurisdiction
      periodicity
      paused
      confirmed
      createdAt
    }
  }
`;
